import styled from 'styled-components';
import { IInputStyled, InputCss } from '../TextInput/Input.styles';
export const AreaInputStyled = styled.textarea<IInputStyled>`
  ${InputCss};
  resize: vertical;
`;
